<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :isRequiredFarms="true"
              :filterOfLots="false"
              :classFarms="`col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4`"
            >
              <template slot="after-lot">
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                  <label for=""
                    >{{ $t('common_words.group_of_activities') }}: *
                  </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect(
                        'activities_group_ids',
                        activities_group
                      ),
                        getActivitiesByGroups()
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm required-group_of_activities"
                    v-model="activities_group_ids"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in activities_group"
                      :key="index"
                      :label="`${
                        item.code ? item.code + '-' + item.name : item.name
                      }`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 pt-3">
                  <label for="">{{ $t('common_words.activities') }}: *</label>
                  <br />
                  <el-select
                    @change="selectAllFromSelect('activities_ids', activities)"
                    clearable
                    collapse-tags
                    style="width: 100%"
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm required-activities"
                    v-model="activities_ids"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="(item, index) in activities"
                      :key="index"
                      :label="`${
                        item.code ? item.code + '-' + item.name : item.name
                      }`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <div v-if="haveData">
        <card
          class="custom-shadow-card-header"
          :title="$t('labor.summary_by_farm')"
        >
          <span>
            <div class="row">
              <div class="col-12">
                <highcharts
                  ref="chartRef"
                  :options="columnChartDrillDown"
                ></highcharts>
              </div>
            </div>
          </span>
        </card>
        <card>
          <el-collapse class="custom-el-collapse" v-model="activeFarm">
            <el-collapse-item
              class="custom-collapse-item collapse-data"
              v-for="(farms, index) in tableData"
              :name="(farms[index].farm_id || '').toString()"
              :key="index"
            >
              <template slot="title">
                <div style="width: 100%">
                  <span style="text-transform: capitalize">
                    <strong>{{ $t('common_words.farm') }}: </strong>
                    {{ farms[index].farm_name }}
                    <strong>{{ getTotalCostByFarm(farms) }}</strong>
                  </span>
                </div>
              </template>
              <div
                class="table-responsive center custom-table-wrapper mt-3 mb-5"
              >
                <table
                  class="table table-striped table-bordered not-last-td table-data custom-sticky-table"
                >
                  <thead>
                    <tr class="cusmtom-thead-color">
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        {{ $t('common_words.group_of_activities') }}
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        {{ $t('common_words.activity') }}
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        {{ $t('common_words.week') }}
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        {{ $t('common_words.quantity') }}
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        {{ $t('labor.unit_of_measure') }}
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        {{ $t('common_words.total') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(labor, index2) in farms" :key="index2">
                      <td v-if="labor.activity_id">
                        {{ labor.activity_group_code }} -
                        {{ labor.activity_group_name }}
                      </td>
                      <td v-if="labor.activity_id">
                        {{ labor.activity_code }} - {{ labor.activity_name }}
                      </td>
                      <td v-else :colspan="`5`">
                        <strong>
                          {{
                            labor.activity_id
                              ? labor.activity_code
                              : $t('common_words.total') +
                                ' ' +
                                $t('uti.mixin_dinamic_charts.by') +
                                ' ' +
                                $t('common_words.week')
                          }}
                        </strong>
                      </td>
                      <td v-if="labor.activity_id" class="text-center">
                        {{ labor.week_number }}
                      </td>
                      <td v-if="labor.activity_id" class="text-center">
                        {{ labor.quantity }}
                      </td>
                      <td v-if="labor.activity_id">
                        {{ labor.unit_production_name }}
                      </td>
                      <td v-if="labor.activity_id" class="text-center">
                        {{ '$ ' + formatMoney(labor.total_cost) }}
                      </td>
                      <td class="text-center" v-else>
                        <strong
                          >{{ '$ ' + formatMoney(labor.total_cost) }}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div
            v-if="isPDF() || isExcel() || isSuper()"
            class="row"
            style="padding-right: 13px; padding-left: 13px; padding-top: 12px"
          >
            <div class="col-6">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToEXCEL"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { getDateToday } from 'src/util/Util';
import { isset } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import Filter from 'src/components/Filter/Filters.vue';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import MixinCharts from 'src/util/mixinCharts';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    highcharts: Chart,
  },
  data() {
    return {
      activeName: 'filter',
      valueCollapse: null,
      activities: [],
      activities_ids: [],
      activities_group: [],
      activities_group_ids: [],
      tableData: [],
      haveData: false,
      columnChartDrillDown: {},
    };
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    dateToday() {
      return getDateToday();
    },
    getDataToExport() {
      const response = { ...this.data_export };
      delete response.route;

      return response;
    },
  },
  mixins: [MixinMasters, MixinExport, MixinMenu, MixinPermissions, MixinCharts],
  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },
  methods: {
    getSelectAll() {
      this.activities_group = this.concatAll(this.activities_group.splice(1));
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      this.haveData = false;
      this.activeFarm = [];
      if (this.activities_group_ids.length == 0) {
        return this.validationInputsRequired('group_of_activities');
      } else if (this.activities_ids.length == 0) {
        return this.validationInputsRequired('activities');
      }
      this.dataFilter = { ...data };
      this.dataFilter.activities_ids = this.activities_ids;
      this.getDataSamples();
    },
    getActivitiesByGroups() {
      if (this.activities_group_ids.length > 0) {
        this.activities_ids = [];
        const groupIds = this.activities_group_ids;
        const groups = this.activities_group;
        const selectedSet = new Set(groupIds.map(Number));

        this.activities = groups
          .filter((group) => selectedSet.has(Number(group.id)))
          .flatMap((group) =>
            Array.isArray(group.activities) ? group.activities : []
          );

        this.activities = this.concatAll(this.activities.splice(1));
      } else {
        this.activities_ids = [];
        this.activities = [];
      }
    },
    getDataSamples() {
      this.showHideLoading(true);
      const route = 'works/activitycostbyfarms';
      const data = {
        ...this.dataFilter,
        route: route,
      };
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data.data;
          const columnChartDrillDown =
            response.data.data.column_chart_drill_down;
          if (this.tableData.length > 0) {
            this.haveData = true;
            this.resetDrilldown('chartRef');
            // Botón a la izquierda
            const drillUpConfig = {
              drillUpButton: {
                position: {
                  align: 'left',
                  x: -3,
                  y: -35,
                },
              },
            };
            this.columnChartDrillDown = this.columns(
              columnChartDrillDown,
              false
            );
            this.columnChartDrillDown.drilldown = {
              ...this.columnChartDrillDown.drilldown,
              ...drillUpConfig,
            };
            for (
              let indexFarm = 0;
              indexFarm < this.tableData.length;
              indexFarm++
            ) {
              const farm = this.tableData[indexFarm];
              const farmId = farm.farm_id;
              this.activeFarm.push(farmId.toString());
            }
          } else {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
        });
    },
    formatMoney(value) {
      return Formatter.formatMoney(Number(value));
    },
    getTotalCostByFarm(farm) {
      let actualValue = 0;
      for (let index = 0; index < farm.length; index++) {
        if (isset(farm[index].activity_id))
          actualValue += Number(farm[index].total_cost);
      }
      actualValue = Number(actualValue.toFixed(2));

      return '$ ' + this.formatMoney(actualValue);
    },
    exportToPDF() {
      let data = {
        data: this.tableData,
        route: 'works/activitycostbyfarms/pdf',
      };

      data.name_file = `${i18n.t('labor.costs_by_activities')}_${
        this.dateToday
      }.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    exportToEXCEL() {
      let data = {
        data: this.tableData,
        route: 'works/activitycostbyfarms/excel',
      };

      data.name_file = `${i18n.t('labor.costs_by_activities')}_${
        this.dateToday
      }.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },
  created() {
    if (this.isIndex()) {
      Promise.all([Axios.getMasters('works/activitiesgroups')]).then(
        ([response_activities_group]) => {
          this.activities_group = this.concatAll(
            response_activities_group.data.data
          );
          this.showHideLoading();
        }
      );
    } else {
      this.showMessageAccess();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },

  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
<style scoped>
.txtcenter {
  text-align: center !important;
}
.custom-table-wrapper {
  max-height: 420px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #dcdfe6;
}

.custom-sticky-table {
  margin-bottom: 0 !important;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-sticky-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #898989;
  color: #fff;
}

.custom-sticky-table tbody td {
  vertical-align: middle;
}

/* opcional: resaltar fila total */
.custom-sticky-table tbody tr.total-row td {
  font-weight: 700;
  background: #fafafa;
}

/* scrollbar opcional */
.custom-table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-table-wrapper::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 4px;
}

.custom-table-wrapper::-webkit-scrollbar-track {
  background: #f2f2f2;
}
</style>
